import Swiper from 'swiper/bundle';

export default () => {
  const home_slider = document.querySelector('.js-hero-home-swiper');
  if (home_slider) {
    const hero_slider = new Swiper(home_slider, {
      slidesPerView: 1,
      effect: 'fade',
      loop: true,
      speed: 1500,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: false,
        transformEl: '.Slide',
      },
      autoplay: {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: 4000,
      },
      pagination: {
        el: ".js-swiper-hero-slider-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="Swiper__PaginationItem ' + className + '">' + (index + 1) + "</span>";
        },
      },
    });
    const slider_wrapper = document.querySelector('.SectionBlock--HeroHome .SectionBlock__Wrapper');
    slider_wrapper.style.height = hero_slider.height < 920 ? '920px' : hero_slider.height+'px';
  }



  const slideContentByRes = () => {
    const slides = document.querySelectorAll('.js-hero-home-swiper .js-slide-standard.js-slide');
    if (slides) {
      slides.forEach(element => {
        let title =  element.querySelector('.js-title');
        let description =  element.querySelector('.js-description');
        if (window.site_vw < 768) {
          title.innerHTML =  title.dataset.mobile
          description.innerHTML =  description.dataset.mobile
        } else {
          title.innerHTML =  title.dataset.desktop
          description.innerHTML =  description.dataset.desktop
        }
      });
    }
  }
  
  slideContentByRes();
  window.addEventListener('resize', () => {
    slideContentByRes();
  });
}